import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { format, parseISO } from 'date-fns';
import { CommponentOptions, getFieldOptions } from '../plagins/data/commponentOptions';
import FormTemplate from '../../template/form/FormTemplate';
import { useIndexedDBSyncV2 } from '../../../database/dataLocal/indexedDBHooks';
import { GlobalContext } from '../../../App';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { createFetchDataServer, getTableData } from '../../../database/fetchData';
import { fullSelectedBlocks, fullSelectedCemeteries, fullSelectedPlots, fullSelectedRows } from '../plagins/data/multiSelectedForm';

const NAME_ENTITY = ' מחירון';

function PaymentUpdate() {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsFormPayments.data);

  const { setTitle, token } = useContext(GlobalContext);
  const { setTotalWidthContainer } = useContext(TemplateContext);

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr, getEntitiesByAttr, addOrUpdateDataPayment } = useQueries();

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value, grave } = location.state || {};

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`עדכון מחירון`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);
  const [loading, setLoading] = useState(true); // מצב טעינה
  // בודק אם נטענו השדות ברירת מחדל
  const [loadingDefaultValue, setLoadingDefaultValue] = useState(false); // מצב טעינה


  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);
  const [rows, setRows] = useState([]);

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field) => {
      return {
        ...field,
        // כאן ניתן להוסיף חוקים לנעילת שדה או להיפך
        disabled: field.disabled && grave !== undefined,
        // כאן ניתן להוסיף חוקים לחובת שדה או להיפך
        required: field.required || false,
        // כאן ניתן להוסיף חוקים להסתרת שדה או להיפך
        show: field?.show || false
      };
    });
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loadingDefaultValue && handleAllDataLoaded();
  }, [context]);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());
    if (value?.unicId) {
      const payment = getEntityByAttr(context?.contextPayments, 'unicId', value?.unicId);

      payment && setLoadingDefaultValue(true)

      let initialFormValues = myColumns()
        ?.filter((field) => field?.name)
        ?.reduce((acc, field) => {
            let fieldValue = payment?.[field.name]
            
            if (field.input === 'date' && payment?.[field.name]) {
              console.log(111, fieldValue);
              
              const dateValue = new Date(payment?.[field.name]);

              console.log(222, dateValue);

              // console.log(333, format(dateValue, 'yyyy-MM-dd'));
              // fieldValue = isNaN(dateValue) ? '' : format(dateValue, 'yyyy-MM-dd'); // בדיקת תקינות התאריך
             fieldValue = format(dateValue, 'yyyy-MM-dd'); // בדיקת תקינות התאריך
            //  fieldValue = isNaN(fieldValue) ? '' : format(fieldValue, 'yyyy-MM-dd'); // בדיקת תקינות התאריך
            }            
            if (fieldValue === '-1') {
              fieldValue = isNaN(fieldValue) ? fieldValue : -1
            }
            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          { unicId: payment?.unicId }
        )        

      fieldAuto(payment, initialFormValues);

      setFormValues(initialFormValues);
    }
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (data) => {

    const emptyData = [CommponentOptions({ value: '', label: '' })]
    setCemeteries(
      [...emptyData, fullSelectedCemeteries(context?.contextCemeteries)]
    );
    setBlocks(
      [...emptyData, fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', data?.cemeteryId))]
    );
    setPlots(
      [...emptyData, fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'blockId', data?.blockId))]
  );
    setRows(
      [...emptyData, fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'plotId', data?.plotId))]
  );
  };

  //לוגיקת הזנה ב cemetery
  const fieldChangeCemeteryId = (event, newFormValues) => {
    delete newFormValues?.blockId;
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    if (event.target.value === -1) {
      setBlocks([
        CommponentOptions({ value: '', label: '' }),
        ...context?.contextBlocks.map((block) => {
          const cemetery = context?.contextCemeteries.find((cemetery) => cemetery?.unicId === block?.cemeteryId);
          return CommponentOptions({
            value: block?.unicId,
            label: block?.blockNameHe,
            dataUnderRigth: {
              title: 'בית עלמין: ',
              value: cemetery?.cemeteryNameHe
            }
          });
        })
      ]);
    } else {
      const blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', event.target.value);
      const plots = context?.contextPlots.filter((plot) => blocks.some((block) => block?.unicId === plot.blockId));
      setBlocks([
        CommponentOptions({ value: '', label: '' }),
        ...blocks.map((block) => {
          const cemetery = context?.contextCemeteries.find((cemetery) => cemetery?.unicId === block?.cemeteryId);
          return CommponentOptions({
            value: block?.unicId,
            label: block?.blockNameHe,
            dataUnderRigth: {
              title: 'בית עלמין: ',
              value: cemetery?.cemeteryNameHe
            }
          });
        })
      ]);
      setPlots([
        CommponentOptions({ value: '', label: '' }),
        ...plots.map((plot) => {
          const block = context?.contextBlocks.find((block) => block?.unicId === plot?.blockId);
          const cemetery = context?.contextCemeteries?.find((cemetery) => cemetery?.unicId === block?.cemeteryId);
          console.log(plot);
          return CommponentOptions({
            value: plot?.unicId,
            label: plot?.plotNameHe,
            dataUnderRigth: { title: 'גוש: ', value: block?.blockNameHe },
            dataUnderLeft: { title: 'בית עלמין: ', value: cemetery?.cemeteryNameHe }
          });
        })
      ]);
    }
  };
  //לוגיקת הזנה ב block
  const fieldChangeBlockId = (event, newFormValues) => {
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;

    const plots = getEntitiesByAttr(context?.contextPlots, 'blockId', event.target.value);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', event.target.value);
    const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId);

    setPlots([
      CommponentOptions({ value: '', label: '' }),
      ...plots.map((plot) => {
        const block = context?.contextBlocks.find((block) => block?.unicId === plot?.blockId);
        const cemetery = context?.contextCemeteries?.find((cemetery) => cemetery?.unicId === block?.cemeteryId);
        return CommponentOptions({
          value: plot?.unicId,
          label: plot?.plotNameHe,
          dataUnderRigth: { title: 'גוש: ', value: block?.blockNameHe },
          dataUnderLeft: { title: 'בית עלמין: ', value: cemetery?.cemeteryNameHe }
        });
      })
    ]);
    return { cemeteryId: cemetery?.unicId };
  };
  //לוגיקת הזנה ב plot
  const fieldChangePlotId = (event, newFormValues) => {
    delete newFormValues?.lineId;

    const plot = getEntityByAttr(context?.contextPlots, 'unicId', event.target.value);
    const rows = getEntitiesByAttr(context?.contextRows, 'plotId', event.target.value);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId);
    const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId);

    setRows([
      CommponentOptions({ value: '', label: '' }),
      ...rows.map((row) => {
        return CommponentOptions({
          value: row?.unicId,
          label: row?.lineNameHe,
          dataUnderRigth: { title: 'חלקה: ', value: plot?.plotNameHe },
          dataUnderLeft: { title: 'גוש: ', value: block?.blockNameHe }
        });
      })
    ]);
    return { blockId: block?.unicId, cemeteryId: cemetery?.unicId };
  };
  //לוגיקת הזנה בשדות הטופס
  const handleChange = (event) => {
    let newFormValues = formValues;

    if (event.target.name === 'cemeteryId') {
      fieldChangeCemeteryId(event, newFormValues);
    }
    if (event?.target?.name === 'blockId') {
      const res = fieldChangeBlockId(event, newFormValues);
      console.log(res);
      newFormValues = { ...newFormValues, cemeteryId: res?.cemeteryId };
    }
    if (event?.target?.name === 'plotId') {
      const res = fieldChangePlotId(event, newFormValues);
      newFormValues = { ...newFormValues, blockId: res?.blockId, cemeteryId: res?.cemeteryId };
    }
    if (event?.target?.name === 'test') {
      setFormValues({ ...newFormValues, [event.target.name]: format(parseISO(event.target.value), 'yyyy-MM-dd') });
    } else {
      setFormValues({ ...newFormValues, [event.target.name]: event.target.value });
    }
  };
  // אימות ערכים
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (plots.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };
  // שליחת הטופס
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoadingData(true);
      let newFormValues = formValues;

      console.log(newFormValues);

      let res = await addOrUpdateDataPayment(newFormValues);
      if (res === 200) {
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
        const dataRows = localTempData.find((item) => item.name === 'dataRows');
        const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
        const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
        const dataPurchases = localTempData.find((item) => item.name === 'dataPurchases');
        const dataBurials = localTempData.find((item) => item.name === 'dataBurials');
        if (dataCemeteries && dataBlocks && dataPlots && dataRows && dataAreaGraves && dataGraves && dataPurchases && dataBurials) {
          setLoading(false);
        }
      }

      fetchDataServer(['purchases', 'burials'], token);
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate
        title={`עריכת ${NAME_ENTITY}`}
        btn={`עדכן`}
        fields={fieldsWithDynamicDisabled}
        columns={columns}
        formValues={formValues}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        options={{
          cemeteryId: cemeteries,
          blockId: blocks,
          plotId: plots,
          lineId: rows,
          plotType: getFieldOptions('plotType', optionsFields, true),
          graveType: getFieldOptions('graveType', optionsFields, true),
          resident: getFieldOptions('resident', optionsFields, true),
          priceDefinition: getFieldOptions('priceDefinition', optionsFields, true),
          buyerStatus: getFieldOptions('buyerStatus', optionsFields, true)
        }}
      />
      <p>
        <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>עדכון מחירון</span>
      </p>
    </>
  );
}

export default PaymentUpdate;
